import api from './api';

export const companyService = {
  // Get company info for current user
  getCompanyInfo: () => api.get('/companyinfo'),
  
  // Check if current user has company info
  hasCompanyInfo: () => api.get('/companyinfo/exists'),
  
  // Create or update company info for current user
  createOrUpdateCompanyInfo: (data) => api.put('/companyinfo', data),
  
  // Delete company info for current user
  deleteCompanyInfo: () => api.delete('/companyinfo')
};